"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = void 0;
exports.colors = {
    backdrop: 'rgba(0, 0, 0, 0.16)',
    border: '#b4c1cc',
    disabled: 'rgba(88, 99, 103, 0.5)',
    error: '#e91e63',
    icon: '#586367',
    paper: '#ffffff',
    primary: '#4a90e2',
    selected: '#2196f3',
    shadow: 'rgba(0, 0, 0, 0.2)',
    textSecondary: 'rgba(0, 0, 0, 0.8)'
};
//# sourceMappingURL=colors.js.map